import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as HelpIcon } from 'assets/icons/Help.svg';
import HelpModal from 'modules/views/shared/HelpModal';

import { useStylesHelp } from '../styles';

export interface IHelpProps {
  isAuthenticated?: boolean;
  styleClass?: string;
}

const HelpButton = ({ styleClass = '', isAuthenticated }: IHelpProps) => {
  const classes = useStylesHelp();
  const { t } = useTranslation();
  const [isHelpModalVisible, setIsHelpModalVisible] = useState(false);

  return (
    <>
      <div
        className={`${classes.helpButton} ${isAuthenticated ? classes.hideHelpButton : ''} ${styleClass}`}
        onClick={() => setIsHelpModalVisible(true)}
      >
        <HelpIcon />
        <span className={classes.helpText}>{t('common.help')}</span>
      </div>
      <HelpModal isVisible={isHelpModalVisible} onClose={() => setIsHelpModalVisible(false)} />
    </>
  );
};

export default memo(HelpButton);
